import {HandThumbDownIcon, HandThumbUpIcon} from '@heroicons/react/24/solid';
import {FunctionComponent, HTMLAttributes} from 'react';

type ThumbsUpDownButtonProps = {
  direction: 'up' | 'down';
  value: number;
  isActive: boolean;
} & HTMLAttributes<HTMLButtonElement>;

export const ThumbsUpDownButton: FunctionComponent<ThumbsUpDownButtonProps> = ({
  direction,
  value,
  isActive,
  onClick,
}) => {
  const buttonInactiveClassName = 'text-gray-400 hover:text-white';
  const buttonActiveClassName = 'text-deepblue hover:opacity-70';
  const buttonClassName = `text-xs font-bold inline align-middle space-x-1 group ${
    isActive ? buttonActiveClassName : buttonInactiveClassName
  } `;

  const iconInactiveClassName = 'stroke-gray-400 group-hover:stroke-white fill-transparent';
  const iconActiveClassName = 'stroke-deepblue fill-deepblue';
  const iconClassName = `inline w-4 h-4 ${isActive ? iconActiveClassName : iconInactiveClassName}`;

  return (
    <button className={buttonClassName} onClick={onClick}>
      {direction === 'up' ? (
        <HandThumbUpIcon className={iconClassName} />
      ) : (
        <HandThumbDownIcon className={iconClassName} />
      )}
      <span>{value}</span>
    </button>
  );
};
